module.exports = __webpack_public_path__ + "img/010_reagan_thumb.45842536.jpg";